module.exports = __webpack_public_path__ + "img/etoile_on.cb36759e.gif";